<template>
  <div class="dapp-box">
    <div class="m-title4">
      <!-- PSC币特征 -->
      {{ $t("study.tokenBox2T1") }}
    </div>
    <div class="m-p">
      <!-- PSC是一种加密货币。这是稀缺的数字货币，您可 -->
      {{ $t("study.tokenBox2T2") }}
    </div>
    <div class="box">
      <div
        class="m-item3"
        v-for="(item, index) in $t('study.psctokenBox2List')"
        :key="index"
      >
        <div class="img">
          <img
            :src="
              require(`../../assets/images/v4/study/tokenBox2${index + 1}.png`)
            "
            alt=""
          />
        </div>
        <div class="t">{{ item.title }}</div>
        <div class="link"></div>
        <div class="android">{{ item.subTitle }}</div>
        <div class="p">
          {{ item.text }}
        </div>
        <!-- <div class="more">
          {{ item.ft }}
          <svg class="icon" aria-hidden="true">
            <use xlink:href="#icon-arrowRight"></use>
          </svg>
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import Store from "../../store";
export default {
  data() {
    return {
      uti: Store.uti,
      store: Store.state,
    };
  },
  methods: {},
};
</script>
<style lang="less" scoped>
.dapp-box {
  padding-top: (37 / 3.75vw);
  background-repeat: no-repeat;
  background-position: 0 60%;
  text-align: center;

  .m-p {
    padding: 0 (14 / 3.75vw);
    margin-top: (13 / 3.75vw);
  }
  .box {
    margin-top: (37 / 3.75vw);
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
}
</style>
